<template>
  <v-container fluid>
    <div class="row row--dense">
      <v-col cols="12" xl="12" lg="12">
        <div class="d-flex justify-space-between flex-wrap" >
          <div class="d-flex bordered qp-tab-nav ">
            <div class="d-flex p-2">
              <template >
                <div class="nv_item d-flex p-4 pointer" @click="gotoPage('/sales-team')">
                  <SvgIcon class="text-xl text-thin-black " text="Sales Teams" >
                    <template v-slot:icon>
                      <DashboardIcon />
                    </template>
                  </SvgIcon>
                </div>
                <v-divider
                    vertical style="background-color: rgba(220, 220, 220, 1)"
                ></v-divider>
              </template>



              <template >
                <div class="nv_item d-flex p-4 pointer"  @click="gotoPage('/sales-team/deals')">
                  <SvgIcon class="text-xl   qp-tab-nav-is-active" text="Sales Deals" >
                    <template v-slot:icon>
                      <AnalyticsIcon />
                    </template>
                  </SvgIcon>
                </div>

              </template>
            </div>
          </div>


        </div>
      </v-col>
    </div>
    <v-row>
      <SalesTeamDeals
          :refreshData="refreshData"
          :salesTeamId="salesTeamId"
          :salesTeam="salesTeamInfo"
          @openDealModal="addDeal"
      />
    </v-row>

    <DealsPopup v-if="addDealDialog"
                :editDialog="addDealDialog"
                :sales-person-id="salesTeamId"
                :deal-id="dealId"
                @closeDeal="closeDeal"
    ></DealsPopup>


  </v-container>
</template>
<script>
import DashboardIcon from "@/assets/images/misc/dashboard-icon.svg";
import AnalyticsIcon from "@/assets/images/misc/dashboard-icon.svg";
import SvgIcon from "@/components/Image/SvgIcon.vue";
import SalesTeamDeals from "@/components/SalesTeam/SalesTeamDeals.vue";
import DealsPopup from "@/components/SalesTeam/Deals/DealsPopup.vue";

export default {
  components: {DealsPopup, SalesTeamDeals, SvgIcon, DashboardIcon,AnalyticsIcon},
  data() {
    return {
      refreshData:false,
      userID: null,
      salesTeam: [],
      salesTeamId: null,
      salesTeamInfo:{},
      search: "",
      addDealDialog: false,
      dealId: null,
    };
  },
  mounted() {

  },
  watch: {

  },
  methods: {
    gotoPage(route){
      this.$router.push(route);
    },

    addDeal(data=null){
      this.addDealDialog = true;
      this.dealId = data?.id;
      this.refreshData  = false;
    },
    closeDeal(){
      this.addDealDialog = false;
      this.refreshData  = true;
    },

    close(){
      this.editDialog = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  //.v-btn.v-btn {
  //  border-color: unset !important;
  //  padding-left: 0 !important;
  //  padding-right: 0 !important;
  //  &:not(:first-child)::before {
  //    content: " ";
  //    background: #a81b1b;
  //    height: 20px;
  //    width: 1px;
  //    position: unset !important;
  //    opacity: 1 !important;
  //    margin-left: 8px;
  //    margin-right: 8px ;
  //  }
  //}

}

</style>
